import React from "react";

export const CRMHorizontalSeperatorLine = (): JSX.Element =>
    (
        <div className={`crm-horizontal-seperator-line`}>
        </div>
    );
